<template>
  <svg v-if="iconFail !== ''" :style="iconStyle">
    <use :xlink:href="iconFail"></use>
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    name: String,
    size: Number
  },
  data() {
    return {
      iconName: '',
      iconFail: '',
      iconStyle: ''
    }
  },
  // =*=生命函数钩子=*=
  // created 是在模版渲染成html或者模版编译进路由前调用
  // mounted 是在模版已经渲染成html之后调用
  // =*=[keep-alive]=*=
  // activated, deactivated 这两个生命周期函数一定是要在使用了keep-alive组件后才会有的，否则则不存在
  // 页面第一次进入，钩子的触发顺序created -> mounted -> activated
  // 退出时触发deactivated。当再次进入（前进或者后退）时，只触发activated
  // activated 中的逻辑不管是否需要缓存都会进行执行
  created () {
    // 指向图标库
    this.iconName = this.name.split('-')[0]
    if (this.iconName === 'ri') {
      this.iconFail = './icon-svg/remixIcon.symbol.svg#' + this.name
    } else if (this.iconName === 'tabler') {
      this.iconFail = './icon-svg/tablerIcon.symbol.svg#' + this.name
    } else {
      this.iconFail = './icon-svg/featherIcon.symbol.svg#' + this.name
    }
    // 图标大小
    if (this.size) {
      this.iconStyle = 'width:' + this.size + '; height:' + this.size
    }
  },
  mounted () {
  },
  activated () {
  },
  // watch 专门负责监听的模块 某些地方有用
  watch: {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components2/theme/common/icon/SvgIcon.vue